/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { get } from 'underscore';
import { useSelector } from '@xstate/react';
import { FormErrorGroup, UnmappedFormErrors } from '@bingads-webui-campaign-react/form-error';
import { AttentionBeaconGroup } from '@bingads-webui-campaign-react/attention-beacon';
import { ActuationGroup } from '@bingads-webui-campaign-react/actuator';
import { withPerformanceMarker } from '@bingads-webui-campaign-react/performance-marker-provider';
import { AdPreview, VideoAdsContainer } from '@bingads-webui-campaign-react/xandr-video-campaign-shared-components';
import { ErrorMessages } from '@bingads-webui-react/validation';
import { ActivityContext } from '@bingads-webui-react/hoc-with-signal';
import { useStepAdsSettingsState } from './use-step-ads-state';

const permissionsSelector = state => get(state, 'context.stepsData.permissions');

const StepAdsSettingsInternal = (props) => {
  const {
    stepService,
    perfMarker,
    scope,
    loadClipchampPlayer,
  } = props;

  const { aid, cid } = scope.values;

  const activity = useContext(ActivityContext);

  const [stepState, stepApi] = useStepAdsSettingsState(stepService, activity);
  const permissions = useSelector(stepService, permissionsSelector);
  const isCTVCopilotVideoGenerationEnabled = permissions && permissions.dynamic && permissions.dynamic.CTVCopilotVideoGeneration;

  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);

  const { onAdsValidation } = stepApi;

  const {
    i18n,
    legacyI18n,
    hideStepHeader,
    ads,
    adsErrors, otherErrors,
    navigationConfirmationPrompt,
    systemErrors,
    areBeaconsActive,
    serverErrors,
    deal,
    biddingScheme,
    showAllValidationErrors,
  } = stepState;

  const getBasicSettingsSection = useCallback(() => (
    <div className={classNames('basic-ads-section')}>
      {i18n.getString(_TL_('Now that you\'ve created your ad group, you can create your ads. Add your videos and the Final URL, and we\'ll show a preview of what your ads might look like.'))}

      <div style={{ display: 'flex', columnGap: '50px' }}>
        <VideoAdsContainer
          currentVideoIndex={currentVideoIndex}
          onAdsValidation={onAdsValidation}
          i18n={i18n}
          legacyI18n={legacyI18n}
          deal={deal}
          dealLoaded
          permissions={permissions}
          perfMarker={perfMarker}
          cid={cid}
          aid={aid}
          ads={ads.data}
          biddingScheme={biddingScheme}
          allowCopilotVideoGeneration={isCTVCopilotVideoGenerationEnabled}
          loadClipchampPlayer={loadClipchampPlayer}
        />
        <div style={{ width: 600, minHeight: 650 }}>
          <AdPreview ads={ads} i18n={i18n} onUpdateCurrentVideoIndex={setCurrentVideoIndex} />
        </div>
      </div>
    </div>), [i18n, stepService, legacyI18n, perfMarker, cid, aid, ads, currentVideoIndex]);

  return (
    <>
      <ActuationGroup actuationProps={{ isActive: areBeaconsActive }}>
        <AttentionBeaconGroup>
          <FormErrorGroup formErrorProps={{ errors: serverErrors, showAllValidationErrors }}>
            {!hideStepHeader &&
            <>
              <h1>{i18n.getString(_TL_('Ads'))}</h1>
              <span>{i18n.getString(_TL_(''))}</span>
            </>
      }
            <div className="ads-server-errors">
              <ErrorMessages messages={adsErrors} />
            </div>
            <div className="other-server-errors">
              <UnmappedFormErrors />
            </div>
            <div className="other-server-errors">
              <ErrorMessages messages={otherErrors} />
            </div>
            <div className="system-errors">
              <ErrorMessages messages={systemErrors} />
            </div>
            {getBasicSettingsSection()}
            {navigationConfirmationPrompt}
          </FormErrorGroup>
        </AttentionBeaconGroup>
      </ActuationGroup>
    </>
  );
};

StepAdsSettingsInternal.propTypes = {
  stepService: PropTypes.shape({}).isRequired,
  perfMarker: PropTypes.shape({}).isRequired,
  scope: PropTypes.shape({
    values: PropTypes.shape({
      aid: PropTypes.string,
      cid: PropTypes.string,
    }),
  }).isRequired,
};

export const StepAdsSettings = withPerformanceMarker(StepAdsSettingsInternal);
